import { getEkidenSdkClient } from "../sdk";

export const requestFunding = async ({
  receiver,
  tokens,
  amounts,
}: {
  receiver: string;
  tokens: string[];
  amounts: number[];
}) => {
  return getEkidenSdkClient().account.fund({
    receiver,
    metadatas: tokens,
    amounts,
  });
};
